import { IBuilderSaveResult } from 'components/EmbeddedBuilder';

import { wizardLinks } from '../wizard/wizardLinks';
import { WizardHandoff } from '../wizard/wizardSubmission';

/** What the Config Studio flows hand to their host's save. */
export type ConfigIntent = 'draft' | 'confirm';

export type ConfigEntity = 'campaign' | 'rule' | 'reward' | 'audience';

export interface ConfigSubmission<V> {
  intent: ConfigIntent;
  values: V;
}

/**
 * The host's save, through the module's create API. It answers the record it created (the same
 * result the embedded module builders hand their host), or `null` when nothing was created, and
 * rejects with the API's message on failure. Either way the flow stays on its review with every
 * answer kept.
 */
export type ConfigSubmit<V> = (
  submission: ConfigSubmission<V>
) => Promise<IBuilderSaveResult | null> | IBuilderSaveResult | null;

/** Fired after every successful save; the campaign wizard's handoff seam. */
export type ConfigHandoff = WizardHandoff;

/** The approval request under maker-checker, else the record itself. */
export const savedRecordRoute = (result: IBuilderSaveResult): string => {
  const request = result.pendingRequestId ?? null;
  switch (result.entity) {
    case 'rule':
      return request !== null
        ? wizardLinks.ruleRequest(result.id, request)
        : wizardLinks.showRule(result.id);
    case 'reward':
      return request !== null
        ? wizardLinks.rewardRequest(result.id, request)
        : wizardLinks.showReward(result.id);
    case 'campaign':
      return request !== null
        ? wizardLinks.campaignRequest(result.id, request)
        : wizardLinks.showCampaign(result.id);
    default:
      return wizardLinks.showAudience(result.id);
  }
};
